import { ComponentType } from 'react'
import { NOT_FOUND } from 'redux-first-router'
import { Route } from './routes.types'
import { Home } from '../components/home'
import { Login } from '../components/login'
import { Budget } from '../components/budget'
import { Expenses } from '../components/expenses'
import { NotFound } from '../components/not-found'
import { IrregularBudget } from '../components/irregular-budget'
import { YearlyExpenses } from '../components/yearly-expenses'

type Page = {
  component: ComponentType
  requiresLogin: boolean
  requiresPassword: boolean
}

export const pages: Record<Route, Page> = {
  'ROUTES/Home': {
    component: Home,
    requiresLogin: false,
    requiresPassword: false,
  },
  'ROUTES/Login': {
    component: Login,
    requiresLogin: true,
    requiresPassword: false,
  },
  'ROUTES/BudgetMonthEntries': {
    component: Budget,
    requiresLogin: true,
    requiresPassword: true,
  },
  'ROUTES/BudgetIrregular': {
    component: IrregularBudget,
    requiresLogin: true,
    requiresPassword: true,
  },
  'ROUTES/BudgetEntries': {
    component: NotFound,
    requiresLogin: true,
    requiresPassword: false,
  },
  'ROUTES/Budget': {
    component: NotFound,
    requiresLogin: true,
    requiresPassword: false,
  },
  'ROUTES/Expenses': {
    component: NotFound,
    requiresLogin: true,
    requiresPassword: false,
  },
  'ROUTES/ExpensesMonth': {
    component: Expenses,
    requiresLogin: true,
    requiresPassword: true,
  },
  'ROUTES/ExpensesYear': {
    component: YearlyExpenses,
    requiresLogin: true,
    requiresPassword: true,
  },
  [NOT_FOUND]: {
    component: NotFound,
    requiresLogin: false,
    requiresPassword: false,
  },
}
